import React from 'react'
import { PropertyDetailsProps } from './PropertyDetails.types'
import {
  PropertyDetailsGrid,
  DetailItem,
  DetailLabel,
  DetailValue,
} from './PropertyDetails.styles'

export const PropertyDetails: React.FC<PropertyDetailsProps> = ({
  details,
  columns = 2,
  className,
}) => {
  return (
    <PropertyDetailsGrid $columns={columns} className={className}>
      {details.map((detail, index) => (
        <DetailItem key={index}>
          <DetailLabel>{detail.label}</DetailLabel>
          <DetailValue>
            {detail.value !== null && detail.value !== undefined
              ? detail.value
              : detail.emptyValue || '—'}
          </DetailValue>
        </DetailItem>
      ))}
    </PropertyDetailsGrid>
  )
}
